import * as React from 'react';
import { DuplicateConstants as ui } from '../Config/UIConstants';
import { colors } from '../styles/colors';
import { CommonActionButton } from './CommonActionButton';

interface IProps {
    fileName: string;
    newPhotoUrl: string;
    matchingPhotoUrl: string;
    onClickIsDuplicate(): void;
    onClickFalseDuplicate(): void;
}

export class DuplicatePhotoPrompt extends React.Component<IProps> {
    public render() {
        return (
            <div style={styles.container}>
                <p style={styles.headerText}>{ui.HEADER(this.props.fileName)}</p>
                <p style={styles.subHeaderText}>{ui.SUB_HEADER}</p>
                <div style={styles.photoRowContainer}>
                    <div style={styles.newPhotoContainer}>
                        <img src={this.props.newPhotoUrl} style={styles.newPhotoImage} />
                        <p style={styles.newPhotoText}>{ui.NEW_PHOTO}</p>
                    </div>

                    <div style={styles.matchingPhotoContainer}>
                        <img src={this.props.matchingPhotoUrl} style={styles.matchingPhoto} />
                        <p style={styles.currentPhotoText}>{ui.CURRENT_PHOTO}</p>
                    </div>
                </div>

                <div style={styles.buttonRow}>
                    <CommonActionButton
                        buttonContent={ui.DUPLICATE}
                        onClick={this.props.onClickIsDuplicate}
                        containerStyle={styles.cancelButton}
                    />
                    <div style={styles.spacer} />
                    <CommonActionButton
                        buttonContent={ui.NO_DUPLICATE}
                        onClick={this.props.onClickFalseDuplicate}
                        containerStyle={styles.button}
                    />
                </div>
            </div>
        );
    }
}

const styles = {
    headerText: {
        fontSize: 25,
        textAlign: 'center',
        width: `100%`,
        marginTop: 40,
    } as React.CSSProperties,
    subHeaderText: {
        fontSize: 18,
        textAlign: 'center',
        width: `100%`,
        marginTop: -25,
        paddingLeft: `10%`,
        paddingRight: `10%`,
    } as React.CSSProperties,
    photoRowContainer: {
        display: 'flex',
        height: 400,
        width: '100%',
        justifyContent: 'space-between',
        marginTop: -45,
    } as React.CSSProperties,
    newPhotoContainer: {
        displayer: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: `85%`,
        marginLeft: `5%`,
        marginRight: `2.5%`,
    } as React.CSSProperties,
    newPhotoImage: {
        height: `100%`,
        width: `100%`,
        objectFit: 'contain',
    } as React.CSSProperties,
    newPhotoText: {
        width: `100%`,
        fontSize: 28,
        color: `black`,
        textAlign: `center`,
        marginTop: 15,
    } as React.CSSProperties,
    matchingPhotoContainer: {
        displayer: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: `85%`,
        marginRight: `5%`,
        marginLeft: `2.5%`,
    } as React.CSSProperties,
    matchingPhoto: {
        height: `100%`,
        width: `100%`,
        objectFit: 'contain',
    } as React.CSSProperties,
    currentPhotoText: {
        width: `100%`,
        fontSize: 28,
        color: `black`,
        textAlign: `center`,
        marginTop: 15,
    } as React.CSSProperties,

    container: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: `rgb(245, 245, 245)`,
        minHeight: 750,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    } as React.CSSProperties,
    cancelButton: {
        width: 350,
        backgroundColor: colors.CANCEL_TEXT,
    },
    button: {
        width: 350,
    },
    spacer: {
        width: 25,
    },
    buttonRow: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        width: '100%',
        marginBottom: 50,
    } as React.CSSProperties,
};



// WEBPACK FOOTER //
// ./src/SharedComponents/DuplicatePhotoPrompt.tsx